import { request } from "../network/request";

/**
 * 获取任务列表
 */

export function getTaskList(params) {
  return request({
    url: "pmp/task/taskList",
    method: "post",
    params: {
      ...params,
    },
  });
}


export function taskExport(params) {
  return request({
    url: "pmp/task/exportTask",
    method: "post",
    params,
  });
}

/**
* 获取认领概况列表
*/
export function getRlmxList(params) {
  return request({
    url: "pmp/task/rlmxList",
    method: "get",
    params,
  });
}

/**
* 任务终止
*/
export function rwzzUpdate(params) {
  return request({
    url: "pmp/task/rwzz",
    method: "get",
    params,
  });
}




// ------------------------------------- 任务查看
/**
 * 基本信息 id
 * @param {*} params 
 * @returns 
 */
export function getBaseInfoDetail(params) {
  return request({
    url: "pmp/task/getTaskDetail",
    method: "get",
    params,
  });
}

/**
 * 查看申请审核列表
 * @param {*} params 
 * @returns 
 */
export function getSqshList(params) {
  return request({
    url: "pmp/task/sqshList",
    method: "get",
    params,
  });
}

/**
 * 任务认领 id
 * @param {*} params 
 * @returns 
 */
export function getRwrlList(params) {
  return request({
    url: "pmp/task/rwrlList",
    method: "get",
    params,
  });
}
/**
 * 任务奖励 id
 * @param {*} params 
 * @returns 
 */

export function getRwjlList(params) {
  return request({
    url: "pmp/task/rwjlList",
    method: "get",
    params,
  });
}
/**
 * 任务认领审核列表
 * @param {*} params
 * @returns
 */
export function getRlshList(params) {
  return request({
    url: "pmp/task/rlshList",
    method: "get",
    params,
  });
}

export function getCgwshList(params) {
  return request({
    url: "pmp/task/cgwshList",
    method: "get",
    params,
  });
}



/**--------------任务认领 */
// 任务认领详情
export function getTaskAuditDetials(params) {
  return request({
    url: "pmp/task/selectTaskAuditDetials",
    method: "get",
    params,
  });
}
/**
 * 任务认领保存
 * @param {*} params 
 * @returns 
 */
export function saveTaskRl(params) {
  return request({
    url: "pmp/task/taskRlSave",
    method: "get",
    params,
  });
}
/**
 * 任务认领保存
 * @param {*} params
 * @returns
 */
export function saveTaskApplyAudit(params) {
  return request({
    url: "pmp/task/taskApplyAudit",
    method: "get",
    params,
  });
}


/**
 * 认领审核人调整
 * @param {*} params
 * @returns
 */
export function getTaskrkshtz(params) {
  return request({
    url: "pmp/task/selectTaskRlDetials",
    method: "get",
    params,
  });
}
/**
 * 任务认领调整审核人保存
 * @param {*} params 
 * @returns 
 */
export function saveTaskRlConfig(params) {
  return request({
    url: "pmp/task/taskRlConfig",
    method: "get",
    params,
  });
}
/**
 * 任务认领审核保存
 * @param {*} params 
 * @returns 
 */
export function saveTaskRlAudit(params) {
  return request({
    url: "pmp/task/taskRlAudit",
    method: "get",
    params,
  });
}


//根据数据类型获取字典列表
export function getDictData(dictType, type) {
  return request({
    url: "system/getDictData",
    method: "get",
    params: {
      dictType,
      type,
    },
  });
}
/**
 * 新增/保存/编辑任务
 * @param {*} params 
 * @returns 
 */
export function saveTask(params) {
  return request({
    url: "pmp/task/saveTask",
    method: "post",
    data: params,
  });
}

/**
 * 获取新增页面中之前保存的数据
 * @returns 
 */
export function getSaveTask() {
  return request({
    url: "pmp/task/getSaveTask",
    method: "get",
  });
}
/**
 * 
 * @param {*} data 
 * @returns 
 */
export function uploadFile(data) {
  return request({
    url: '/pmp/task/uploadFile',
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

/**
 * 删除文件
 * @param {*} data 
 * @returns 
 */
export function deleteFile(data) {
  return request({
    url: '/pmp/task/deleteMbFile',
    method: 'POST',
    params: data,
  })
}
/**
 * 获取编辑页面信息
 * @param {*} id 
 * @returns 
 */
export function getEditTask(id) {
  return request({
    url: "pmp/task/getTaskById",
    method: "get",
    params: { id }
  });
}

/**
 * 编辑
 * @param {*} data 
 * @returns 
 */
export function saveEditTask(data) {
  return request({
    url: "pmp/task/updateTask",
    method: "post",
    data,
  });
}

/**
 * 新增，编辑页获取积分
 * @param {*} data 
 * @returns 
 */
export function getJf(data) {
  return request({
    url: "pmp/task/getJf",
    method: "get",
    params: data,
  });
}

/**
 * 获取任务进度
 * @param {*} data 
 * @returns 
 */
export function getTaskProgress(data) {
  return request({
    url: "pmp/task/selectTaskProgress",
    method: "get",
    params: data,
  });
}

